import { render, staticRenderFns } from "./productivityReports.vue?vue&type=template&id=4ae026f4&scoped=true"
import script from "./productivityReports.vue?vue&type=script&lang=js"
export * from "./productivityReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae026f4",
  null
  
)

export default component.exports